/*
 *
 * AdminPage / Gifs / GifDetail
 *
 * Read-only detail for a single GIF session. Backed by GET /api/v3/admin/gifs/:id
 * → ADMIN_GET_GIF_SHAPE ({ id, approved, channel: { id, name } }), verified
 * against Api::V3::Admin::GifsController#show. The shape carries no media URLs or
 * device telemetry (GifMapper only emits these three fields for the admin
 * shape), so this screen shows what the API actually returns — id, approval
 * status, and the owning channel.
 */

import React from "react";
import { useParams, useNavigate } from "react-router-dom";

import Loader from "components/Loader";
import { useAdminGif } from "../api/queries";
import {
  Wrapper,
  BackLink,
  DetailHeading,
  FieldGrid,
  Field,
  DetailLabel,
  FieldValue,
  StatusPill,
} from "./styledComponents";

const GifDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: gif, isLoading, isError } = useAdminGif(id);

  if (isLoading) {
    return (
      <Wrapper>
        <div data-testid="gif-detail-loading">
          <Loader />
        </div>
      </Wrapper>
    );
  }

  if (isError || !gif) {
    return (
      <Wrapper>
        <BackLink type="button" onClick={() => navigate("/admin/gifs")}>
          ← Back to GIFs
        </BackLink>
        <p className="admin-gifs__error">Couldn’t load this GIF.</p>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <BackLink type="button" onClick={() => navigate("/admin/gifs")}>
        ← Back to GIFs
      </BackLink>
      <DetailHeading>
        <h1>GIF #{gif.id}</h1>
        <StatusPill $approved={!!gif.approved}>
          {gif.approved ? "Approved" : "Pending"}
        </StatusPill>
      </DetailHeading>

      <FieldGrid>
        <Field>
          <DetailLabel>ID</DetailLabel>
          <FieldValue>{gif.id}</FieldValue>
        </Field>
        <Field>
          <DetailLabel>Channel</DetailLabel>
          <FieldValue>{gif.channel?.name || "—"}</FieldValue>
        </Field>
        <Field>
          <DetailLabel>Channel ID</DetailLabel>
          <FieldValue>{gif.channel?.id ?? "—"}</FieldValue>
        </Field>
        <Field>
          <DetailLabel>Approved</DetailLabel>
          <FieldValue>{gif.approved ? "Yes" : "No"}</FieldValue>
        </Field>
      </FieldGrid>
    </Wrapper>
  );
};

export default GifDetail;
